import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { IoInformationCircle } from "react-icons/io5";
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { FaPencilAlt, FaPlus, FaTrash } from "react-icons/fa";
import { FaSimplybuilt } from "react-icons/fa6";
import axios from 'axios';
import './edit-department.css';

export default function EditDepartments() {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: '',
    types: [],
  });
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await axios.get(`https://backend.ems.hiradentallab.com/api/departments/${id}`);
        setFormData({
          name: response.data.name || '',
          types: response.data.types || [''],
        });
      } catch (error) {
        console.error('Error fetching department:', error);
        alert('Failed to fetch department details');
      }
    };

    fetchDepartment();
  }, [id]);

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    if (name === 'name') {
      setFormData({
        ...formData,
        name: value
      });
    } else if (name === 'type') {
      const updatedTypes = [...formData.types];
      updatedTypes[index] = value;
      setFormData({
        ...formData,
        types: updatedTypes
      });
    }
  };

  const addTypeField = () => {
    setFormData({
      ...formData,
      types: [...formData.types, '']
    });
  };

  const removeTypeField = (index) => {
    const updatedTypes = formData.types.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      types: updatedTypes
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const filteredTypes = formData.types.filter(type => type.trim() !== '');

    try {
      const response = await axios.put(`https://backend.ems.hiradentallab.com/api/departments/update/${id}`, {
        name: formData.name,
        types: filteredTypes,
      });
      console.log('Department updated successfully:', response.data);
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
        navigate('/departments');
      }, 3000);
    } catch (error) {
      console.error('Error updating department:', error);
      alert(error.response?.data?.message || 'An error occurred while updating the department.');
    }
  };

  return (
    <div className="container-fluid">
      <div>
        <h1 className="edit-department-title">
          <IoInformationCircle className="salary-icon" /> Departments Information
        </h1>
        <hr />
        <h2 className="edit-department-subtitle">
          <FaSimplybuilt className="salary-icon" /> Edit Department Details
        </h2>
        <hr />

        <div className="table-container">
          {showAlert && (
            <Alert variant="success" className="alert-message" onClose={() => setShowAlert(false)} dismissible>
              Department updated successfully!
            </Alert>
          )}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" className="form-label">
                Department Name <span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                className="form-control department-input"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group mt-4">
              <label className="form-label">
                Department Types (Add as many as needed)
              </label>
              {formData.types.map((type, index) => (
                <div key={index} className="d-flex align-items-center mb-3 type-input-container">
                  <input
                    type="text"
                    name="type"
                    className="form-control department-input type-input"
                    value={type}
                    onChange={(e) => handleChange(e, index)}
                    placeholder={`Type ${index + 1}`}
                  />
                  <button
                    type="button"
                    className="btn btn-icon btn-remove"
                    onClick={() => removeTypeField(index)}
                  >
                    <FaTrash />
                  </button>
                </div>
              ))}
              <button
                type="button"
                className="btn btn-icon btn-add-type"
                onClick={addTypeField}
              >
                <FaPlus className="btn-add-icon" />
              </button>
            </div>

            <div className="py-3">
              <button className="btn btn-primary btn-submit" type="submit">
                <FaPencilAlt className="me-2" /> Update Department
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}